import {
  IsFullAccess,
  formatQueryRes,
  regionHaInstanceApi,
  regionHaSnapshotApi,
  useAppDispatch,
  useAppSelector,
  useGetHaSnapshotListQuery,
  useRevertHaSnapShotMutation
} from '@monorepo/shared';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { List, Loader, Message, Stack, useToaster } from 'rsuite';

import CopyIcon from '@rsuite/icons/Copy';
import { SnapshotCreateBtn } from './SnapshotCreate';
import {
  ErrorToaster,
  InstanceConfirmBtn,
  InstanceStatus
} from './InstanceStatus';
import { HomeElms, InstanceAction } from '../../config/const';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
interface IProps {
  region: Record<string, any>;
  action: number | string;
  sn: string;
}
export const InstanceSnapshot = ({ region, action, sn }: IProps) => {
  const { instanceId, accountId, groupId } = useParams();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const [disabled, setDisabled] = useState<boolean>(false);
  const [regionObj, setRegionObj] = useState<Record<string, any>>({});
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [isAccountFullAccess, setIsAccountFullAccess] =
    useState<boolean>(false);
  const [taskAction, setTaskAction] = useState<number | string>(action);
  const { data, isFetching, isLoading } = useGetHaSnapshotListQuery(
    formatQueryRes({
      // account_id: accountId,
      account: currentAccount,
      instance_id: instanceId,
      region: region
    }),
    { skip: !region?.token }
  );
  const [items, setItems] = useState<Record<string, any>[]>([]);
  const [maxCount, setMaxCount] = useState<number>(1);
  const [snapshotRevert, revertResult] = useRevertHaSnapShotMutation();
  const dispatch = useAppDispatch();
  const toaster = useToaster();
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.snapshot_list) {
      setItems(data?.snapshot_list);
    }
    setMaxCount(data?.max_allow_snapshot_count || 1);
  }, [data]);
  useEffect(() => {
    region?.token && setRegionObj(region);
  }, [region]);
  useEffect(() => {
    setDisabled(action !== 0);
    setIsCheck(
      action === InstanceAction.createSnapshot ||
        action === InstanceAction.revertSnapshot
    );
    setTaskAction(action);
  }, [action]);

  useEffect(() => {
    if (revertResult?.isSuccess) {
      setTaskAction(InstanceAction.revertSnapshot);
      setIsCheck(true);
    }
    if (revertResult?.isError) {
      ErrorToaster({
        toaster,
        error: revertResult.error,
        title: 'Revert Snapshot Failed!'
      });
    }
  }, [revertResult]);

  useEffect(() => {
    if (
      IsFullAccess(currentAccount, HomeElms.fcName) ||
      currentAccount?.user_fullaccess
    ) {
      setIsAccountFullAccess(true);
    } else {
      setIsAccountFullAccess(false);
    }
  }, [currentAccount]);

  return (
    <div className="grid-item ">
      <div className="grid-header">
        <div className="title">
          {/* <i className="icon-fortinetone-productViewIcon"></i> */}
          <CopyIcon style={{ marginRight: '10px' }} />
          Snapshot
        </div>
        {!isCheck && !disabled && isAccountFullAccess && (
          <SnapshotCreateBtn
            region={region}
            maxNumber={maxCount}
            callBackFn={() => {
              setTaskAction(InstanceAction.createSnapshot);
              setIsCheck(true);
            }}
          />
        )}
      </div>
      <div className="grid-content">
        {isLoading || isFetching ? (
          <div style={{ height: '100%', position: 'relative' }}>
            <Loader size="xs" content="Loading..." center />
          </div>
        ) : isCheck ? (
          <div
            style={{ display: 'grid', placeItems: 'center', height: '100%' }}
          >
            <InstanceStatus
              action={taskAction}
              group_id={currentAccount?.group_id}
              account_id={accountId || ''}
              user_id={currentAccount?.user_id || ''}
              access_from_user_id={currentAccount?.access_from?.user_id || ''}
              instance_id={instanceId || ''}
              region={region}
              license_sn={sn || ''}
              callBackFn={(obj: any) => {
                // only refetch snapshot list when create
                if (obj?.data?.arg?.action === InstanceAction.createSnapshot) {
                  console.info('snapshot create done data', obj?.data);
                  dispatch(
                    regionHaSnapshotApi.util.invalidateTags([
                      { type: 'Snapshot', id: instanceId }
                    ])
                  );
                } else if (
                  obj?.data?.arg?.action === InstanceAction.revertSnapshot
                ) {
                  console.info('snapshot revert done data', obj?.data);
                  dispatch(
                    regionHaInstanceApi.util.invalidateTags(['RegionInstance'])
                  );
                  dispatch(
                    regionHaInstanceApi.util.invalidateTags(['VmStatus'])
                  );
                  const navigateURL = currentAccount?.group_id
                    ? `/group/accounts/${currentAccount.group_id}/${accountId}`
                    : `/organization/${accountId}`;
                  // navigate(`/organization/${accountId}`);
                  navigate(navigateURL);
                }
                setIsCheck(false);
              }}
            />
          </div>
        ) : !items.length ? (
          <div
            style={{ display: 'grid', placeItems: 'center', height: '100%' }}
          >
            No Snapshots
          </div>
        ) : (
          <List size="sm" className="custom-overflow">
            {items.map((item: Record<string, any>, index: number) => (
              <List.Item key={index} index={index}>
                <Stack justifyContent="space-between">
                  <Stack.Item>{item.name}</Stack.Item>
                  <Stack.Item>{item.desc}</Stack.Item>
                  <div
                    style={{
                      width: '110px',
                      display: 'grid',
                      placeItems: 'center'
                    }}
                  >
                    <InstanceConfirmBtn
                      title="Snapshot Revert"
                      btnText="Revert"
                      disabled={isCheck || disabled}
                      content={`Are you sure want to revert snapshot: ${item?.name}`}
                      callBackFn={() => {
                        snapshotRevert({
                          group_id: currentAccount?.group_id,
                          account_id: accountId,
                          instance_id: instanceId,
                          user_id: currentAccount.user_id,
                          access_from_user_id:
                            currentAccount.access_from_user_id ||
                            currentAccount.access_from?.user_id,
                          region: region,
                          snapshot_id: item.id
                        });
                      }}
                    />
                  </div>
                </Stack>
              </List.Item>
            ))}
          </List>
        )}
      </div>
    </div>
  );
};
